import {
  GET_N8N_WORKFLOW_QUERY,
  LIST_N8N_WORKFLOWS_QUERY,
} from "../queries/n8nWorkflowQueries";
import {
  CREATE_N8N_WORKFLOW_MUTATION,
  UPDATE_N8N_WORKFLOW_MUTATION,
  DELETE_N8N_WORKFLOW_MUTATION,
  EXECUTE_N8N_WORKFLOW_MUTATION,
} from "../mutations/n8nWorkflowMutations";
import { n8nClient } from "../apis/n8nWorkflowClient";

// Action Types
export const GET_N8N_WORKFLOW = "GET_N8N_WORKFLOW";
export const GET_N8N_WORKFLOW_SUCCESS = "GET_N8N_WORKFLOW_SUCCESS";
export const GET_N8N_WORKFLOW_FAILURE = "GET_N8N_WORKFLOW_FAILURE";

export const LIST_N8N_WORKFLOWS = "LIST_N8N_WORKFLOWS";
export const LIST_N8N_WORKFLOWS_SUCCESS = "LIST_N8N_WORKFLOWS_SUCCESS";
export const LIST_N8N_WORKFLOWS_FAILURE = "LIST_N8N_WORKFLOWS_FAILURE";

export const CREATE_N8N_WORKFLOW = "CREATE_N8N_WORKFLOW";
export const CREATE_N8N_WORKFLOW_SUCCESS = "CREATE_N8N_WORKFLOW_SUCCESS";
export const CREATE_N8N_WORKFLOW_FAILURE = "CREATE_N8N_WORKFLOW_FAILURE";

export const UPDATE_N8N_WORKFLOW = "UPDATE_N8N_WORKFLOW";
export const UPDATE_N8N_WORKFLOW_SUCCESS = "UPDATE_N8N_WORKFLOW_SUCCESS";
export const UPDATE_N8N_WORKFLOW_FAILURE = "UPDATE_N8N_WORKFLOW_FAILURE";

export const DELETE_N8N_WORKFLOW = "DELETE_N8N_WORKFLOW";
export const DELETE_N8N_WORKFLOW_SUCCESS = "DELETE_N8N_WORKFLOW_SUCCESS";
export const DELETE_N8N_WORKFLOW_FAILURE = "DELETE_N8N_WORKFLOW_FAILURE";

export const EXECUTE_N8N_WORKFLOW = "EXECUTE_N8N_WORKFLOW";
export const EXECUTE_N8N_WORKFLOW_SUCCESS = "EXECUTE_N8N_WORKFLOW_SUCCESS";
export const EXECUTE_N8N_WORKFLOW_FAILURE = "EXECUTE_N8N_WORKFLOW_FAILURE";

export const LIST_N8N_CLOUD_WORKFLOWS_REQUEST =
  "LIST_N8N_CLOUD_WORKFLOWS_REQUEST";
export const LIST_N8N_CLOUD_WORKFLOWS_SUCCESS =
  "LIST_N8N_CLOUD_WORKFLOWS_SUCCESS";
export const LIST_N8N_CLOUD_WORKFLOWS_FAILURE =
  "LIST_N8N_CLOUD_WORKFLOWS_FAILURE";

export const GET_N8N_EXECUTION_HISTORY = "GET_N8N_EXECUTION_HISTORY";
export const GET_N8N_EXECUTION_HISTORY_SUCCESS =
  "GET_N8N_EXECUTION_HISTORY_SUCCESS";
export const GET_N8N_EXECUTION_HISTORY_FAILURE =
  "GET_N8N_EXECUTION_HISTORY_FAILURE";

// Action Creators
export const getN8nWorkflow = (tenantId, workflowId) => ({
  type: GET_N8N_WORKFLOW,
  payload: { tenantId, workflowId },
});

export const getN8nWorkflowSuccess = (workflow) => ({
  type: GET_N8N_WORKFLOW_SUCCESS,
  payload: workflow,
});

export const getN8nWorkflowFailure = (error) => ({
  type: GET_N8N_WORKFLOW_FAILURE,
  payload: error,
});

export const getN8nExecutionHistory = (tenantId, workflowId) => ({
  type: GET_N8N_EXECUTION_HISTORY,
  payload: { tenantId, workflowId },
});

export const getN8nExecutionHistorySuccess = (history) => ({
  type: GET_N8N_EXECUTION_HISTORY_SUCCESS,
  payload: history,
});

export const getN8nExecutionHistoryFailure = (error) => ({
  type: GET_N8N_EXECUTION_HISTORY_FAILURE,
  payload: error,
});

export const listN8nWorkflows = (tenantId) => ({
  type: LIST_N8N_WORKFLOWS,
  payload: { tenantId },
});

export const listN8nWorkflowsSuccess = (workflows) => ({
  type: LIST_N8N_WORKFLOWS_SUCCESS,
  payload: workflows,
});

export const listN8nWorkflowsFailure = (error) => ({
  type: LIST_N8N_WORKFLOWS_FAILURE,
  payload: error,
});

export const createN8nWorkflow = (input) => ({
  type: CREATE_N8N_WORKFLOW,
  payload: input,
});

export const createN8nWorkflowSuccess = (workflow) => ({
  type: CREATE_N8N_WORKFLOW_SUCCESS,
  payload: workflow,
});

export const createN8nWorkflowFailure = (error) => ({
  type: CREATE_N8N_WORKFLOW_FAILURE,
  payload: error,
});

export const updateN8nWorkflow = (input) => ({
  type: UPDATE_N8N_WORKFLOW,
  payload: input,
});

export const updateN8nWorkflowSuccess = (workflow) => ({
  type: UPDATE_N8N_WORKFLOW_SUCCESS,
  payload: workflow,
});

export const updateN8nWorkflowFailure = (error) => ({
  type: UPDATE_N8N_WORKFLOW_FAILURE,
  payload: error,
});

export const deleteN8nWorkflow = (input) => ({
  type: DELETE_N8N_WORKFLOW,
  payload: input,
});

export const deleteN8nWorkflowSuccess = (result) => ({
  type: DELETE_N8N_WORKFLOW_SUCCESS,
  payload: result,
});

export const deleteN8nWorkflowFailure = (error) => ({
  type: DELETE_N8N_WORKFLOW_FAILURE,
  payload: error,
});

export const executeN8nWorkflow = (input) => ({
  type: EXECUTE_N8N_WORKFLOW,
  payload: input,
});

export const executeN8nWorkflowSuccess = (result) => ({
  type: EXECUTE_N8N_WORKFLOW_SUCCESS,
  payload: result,
});

export const executeN8nWorkflowFailure = (error) => ({
  type: EXECUTE_N8N_WORKFLOW_FAILURE,
  payload: error,
});

// List N8n Cloud Workflows
export const listN8nCloudWorkflowsRequest = (payload) => ({
  type: LIST_N8N_CLOUD_WORKFLOWS_REQUEST,
  payload,
});

export const listN8nCloudWorkflowsSuccess = (workflows) => ({
  type: LIST_N8N_CLOUD_WORKFLOWS_SUCCESS,
  payload: workflows,
});

export const listN8nCloudWorkflowsFailure = (error) => ({
  type: LIST_N8N_CLOUD_WORKFLOWS_FAILURE,
  payload: error,
});
